import React, { useState } from "react";
import { motion } from "framer-motion";

import styled from "styled-components";

function Mamber(props) {
  const { img, first_name, post, click, last_name } = props;
  const [show, setShow] = useState(false);

  const handleMemberClick = () => {
    setShow(!show);
    click();
  };

  return (
    <div>
      <motion.div
        className="animate"
        animate={{ opacity: 1, y: 0 }}
        initial={{ opacity: 0, y: 0 }}
        transition={{ duration: 0.8, ease: "easeInOut", delay: 0.1 }}
      >
        <Styles
          {...props}
          className="container-member"
          onClick={handleMemberClick}
        >
          <span>
            <img src={img} alt={"image" + post} />
            <h3>
              {first_name} {last_name}
            </h3>
            <p>{post}</p>
          </span>
        </Styles>
      </motion.div>
    </div>
  );
}

export default Mamber;

const Styles = styled.div`
  border-radius: 8px;
  cursor: pointer;
  height: 100%;
  span {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  img {
    border-radius: 50%;
    margin: 15px 0 10px;
    width: 60%;
    height: 60%;
  }
  h3 {
    font-size: 15px;
    font-weight: bold;
  }
  p {
    margin: 0;
    padding-bottom: 10px;
  }
`;
